import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import { NewRTElement, RTElement, UnityRTElement } from '@@api/services/rtelements/schemas';
import { deserializeRTElement, serializeRTElement } from '@@api/services/rtelements/transformers';
import { PaginationParams, SearchParams } from '@@api/utils/schemas/queryParams';
import config from '@@config';

export const rtelementsService = defineService(
    (defineEndpoint) => ({
        rtElements: {
            getAll: defineEndpoint({
                method: 'GET',
                path: '/rt-elements',
                query: z.object({
                    ...SearchParams.pick({ q: true, tenantIds: true }).shape,
                    ...PaginationParams.shape,
                }),
                responses: {
                    200: z.array(UnityRTElement.transform(deserializeRTElement)),
                },
            }),
            get: defineEndpoint({
                method: 'GET',
                path: '/rt-elements/:id',
                omitContentLanguageFromKey: true,
                pathParams: z.object({
                    id: RTElement.shape.id,
                }),
                responses: {
                    200: UnityRTElement.transform(deserializeRTElement),
                },
            }),
            put: defineEndpoint({
                method: 'PUT',
                path: '/rt-elements/:id',
                pathParams: z.object({
                    id: RTElement.shape.id,
                }),
                body: RTElement.transform(serializeRTElement),
                responses: {
                    200: UnityRTElement.transform(deserializeRTElement),
                },
            }),
            post: defineEndpoint({
                method: 'POST',
                path: '/rt-elements',
                body: NewRTElement.transform(serializeRTElement),
                responses: {
                    201: UnityRTElement.transform(deserializeRTElement),
                },
            }),
            delete: defineEndpoint({
                method: 'DELETE',
                path: '/rt-elements/:id',
                pathParams: z.object({
                    id: RTElement.shape.id,
                }),
                responses: {
                    204: z.never(),
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.rtElementsUrl,
    },
);
